import { Document } from '@/DTOS/User/Document';
import { Search } from '@/DTOS/User/Search';
import request from '../../utils/request';

const UserService = {
  search: (search: Search) => {
    return request('/user/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  docs: (document: Document) => {
    return request(
      '/user/docs',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: { ...document } }),
      },
      true
    );
  },

  upsert: (
    id: any,
    formData: {
      name: any;
      email: any;
      password: any;
      isActive: any;
      userGroupId: any;
      signature?: any;
      userAdministrationCompanies: any;
      userPersonalData: {
        name: any;
        cnp: any;
        series: any;
        seriesNo: any;
        spclep: any;
        dateRelease: any;
        dateExpiration: any;
        dateOfBirth: any;
        address: any;
        county: any;
        email: any;
        phone: any;
        phonePersonal: any;
      };
      userPermission: { configuration: any; rols: any };
    }
  ) => {
    return request('/user/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          name: formData.name,
          email: formData.email,
          password: formData.password,
          isActive: formData.isActive,
          userGroupId: formData.userGroupId,
          signature: formData.signature,
          userAdministrationCompanies: formData?.userAdministrationCompanies
            ? formData?.userAdministrationCompanies
            : null,
          userPersonalData: formData?.userPersonalData
            ? {
                name: formData?.userPersonalData?.name,
                cnp: formData?.userPersonalData?.cnp,
                series: formData?.userPersonalData.series,
                seriesNo: formData?.userPersonalData.seriesNo,
                spclep: formData?.userPersonalData.spclep,
                dateRelease: formData?.userPersonalData.dateRelease,
                dateExpiration: formData?.userPersonalData.dateExpiration,
                dateOfBirth: formData?.userPersonalData.dateOfBirth,
                address: formData?.userPersonalData.address,
                county: formData?.userPersonalData.county,
                email: formData?.userPersonalData.email,
                phone: formData?.userPersonalData.phone,
                phonePersonal: formData?.userPersonalData.phonePersonal,
              }
            : null,
          userPermission: formData?.userPermission
            ? {
                configuration: formData?.userPermission?.configuration || '',
                rols: formData?.userPermission?.rols,
              }
            : null,
        },
      }),
    });
  },

  updatePassword: (password: any) => {
    return request('/user/updatePassword', {
      method: 'POST',
      body: JSON.stringify({
        request: password,
      }),
    });
  },

  updateSignature: (signature?: any) => {
    return request('/user/updateSignature', {
      method: 'POST',
      body: JSON.stringify({
        request: signature,
      }),
    });
  },
};

export default UserService;
